<template>
<div id="app" class="container">
  <div style="background: #000000; height: 4.5em;" class="d-flex justify-content-center align-items-center py-3 my-3">
    <img src="https://s3-ap-northeast-1.amazonaws.com/bibap.bible.or.jp/images/icon-128.png" class="mw-100 h-100">
    <h5 class="text-light m-0 ml-2" style="font-size: 1.1em">ウェブバイブル</h5>
  </div>
  <div class="bible-tool-wrapper">
    <app-bible-tool class="bible-tool-wrapper" />
  </div>
  <div class="alert-wrapper position-fixed">
      <b-alert :variant="item.variant" show v-for="item in $store.state.ui.flash" v-html="item.text"></b-alert>
  </div>
  <app-ajax-loading />
</div>
</template>

<script>
import _ from 'lodash'
import AppAjaxLoading from '@/components/AppAjaxLoading.vue'
import AppBibleTool from '@/components/AppBibleTool.vue'

export default {
  name: 'app',
  components: {
    AppAjaxLoading,
    AppBibleTool
  },
  computed: {
  },
  watch: {
  },
  methods: {
  },

  async created () {
  },

  async mounted () {
    window.setInterval(() => {
      this.$store.dispatch('uiPlayFlash')
    }, 1000)
  },

  beforeDestroy: function () {
  },
}
</script>

